export default __webpack_public_path__ + "static/nuno-a865ace4b53f56b9eb71902bd94b2c76.jpeg";